import { useEffect, useState } from 'react';

export function useChatScrollHandler(chatContainerRef, onScrollToTop, identifier) {
  const [heightFromBottom, setHeightFromBottom] = useState(0);

  const handleScroll = (e) => {
    const { currentTarget } = e;

    if (currentTarget.scrollHeight + currentTarget.scrollTop - currentTarget.clientHeight === 0) {
      onScrollToTop();
    }
    setHeightFromBottom(
      currentTarget.scrollHeight - currentTarget.scrollTop - currentTarget.clientHeight
    );
  };

  useEffect(() => {
    const container = chatContainerRef.current;
    if (!container) return;

    container.addEventListener('scroll', handleScroll);

    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, [chatContainerRef, identifier]);

  return [heightFromBottom, setHeightFromBottom];
}



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/MessageScreenBody/useChatScrollHandler.js